import * as React from 'react';

function GuestConnectIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20.517 4H9.212A1.483 1.483 0 0 0 7.73 5.482v.774H3.482A1.483 1.483 0 0 0 2 7.738v8.168a1.483 1.483 0 0 0 1.482 1.482h1.222l-.046 2.011a.66.66 0 0 0 .654.669.66.66 0 0 0 .398-.133l3.336-2.547h5.74a1.486 1.486 0 0 0 1.468-1.263l2.035 1.552a.66.66 0 0 0 .694.065.66.66 0 0 0 .357-.599l-.045-2.011h1.221A1.484 1.484 0 0 0 22 13.65V5.482A1.484 1.484 0 0 0 20.517 4m-5.5 11.906a.23.23 0 0 1-.23.228h-5.74c-.274 0-.54.09-.757.256l-2.35 1.792.031-1.361a.67.67 0 0 0-.672-.687H3.482a.23.23 0 0 1-.229-.228V7.738a.23.23 0 0 1 .229-.229h11.304a.23.23 0 0 1 .23.229zm5.73-2.256a.23.23 0 0 1-.23.229h-1.818a.67.67 0 0 0-.672.686l.032 1.361-1.788-1.363-.001-.001V7.738a1.484 1.484 0 0 0-1.484-1.482H8.984v-.774a.23.23 0 0 1 .228-.229h11.305a.23.23 0 0 1 .23.229z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.023 12.716a.882.882 0 1 0 0-1.763.882.882 0 0 0 0 1.763m3.111 0a.882.882 0 1 0 0-1.763.882.882 0 0 0 0 1.763m3.086 0a.882.882 0 1 0 0-1.763.882.882 0 0 0 0 1.763"
  }));
}

export { GuestConnectIcon };
